import React, { FC } from 'react';
import styled from 'styled-components';

export interface OptionProps {
	className: string;
	optionValue: string | undefined;
	children?: React.ReactNode;
	soldOut?: boolean;
	save?: number;
	doOnClick: (arg0: string) => void;
}

const Disabled = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #fff;
	opacity: 0.6;
	z-index: 2;
	pointer-events: none;
`;

const Option: FC<OptionProps> = props => {
	const { className, optionValue, doOnClick, soldOut, children } = props;

	return (
		<div
			className={className}
			onClick={() => {
				!soldOut && doOnClick(optionValue ?? '');
			}}
		>
			{soldOut && <Disabled />}
			{children}
		</div>
	);
};

export default Option;
